import { Directive, ElementRef, Injector } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

@Directive({
  selector: 'insight-page'
})
export class InsightPageDirective extends UpgradeComponent  {
  constructor(elementRef: ElementRef, injector: Injector) {
      super('ng1InsightPage', elementRef, injector);
  }
}
